import gql from 'graphql-tag';

export default gql`
  fragment ConsultationFragment on Consultation {
    _id
    type
    phone
    description
    entity {
      _id
      title
    }
    consultationStatus
    userName
    createdAt
  }
`;
